import React from "react"
import PropTypes from "prop-types"
import Style from "@/components/PartsViewer/v2/PrintShareWindow/index.module.scss"

const PrintAndShare = props => {
  const { showPopup, setShowPopup, contents } = props
  if (!showPopup) return null
  return (
    <div className={Style.PrintShareWindow}>
      {showPopup ? (
        <button
          className="bg-overlay-print"
          onClick={() => setShowPopup(false)}
        ></button>
      ) : null}
      <div className="print-modal">{contents}</div>
    </div>
  )
}

PrintAndShare.propTypes = {
  showPopup: PropTypes.bool.isRequired,
  setShowPopup: PropTypes.func.isRequired,
  contents: PropTypes.any.isRequired,
}

export default PrintAndShare
